import React from "react";
import "../styles/Pricing.css";
import { CgArrowLongUp } from "react-icons/cg";
import BantuEd from "../assets/BantuEd.png";
import Egolu from "../assets/egolu-app.png";
import AfricaBlockChainImage from "../assets/left-side-image-portfolio.jpeg";
import AfroLifestyleImage from "../assets/right-side-image-portfolio.png";
import BlogPageLaptop from "../assets/blog_page_laptop.png";
import bloglist1 from "../assets/bloglist1.png";
import bloglist2 from "../assets/bloglist2.png";
import bloglist3 from "../assets/bloglist3.png";
import Carousel from "../components/ArticlesCarousel";
import CallToActionSection from "../components/CallToActionSection";

function Blog() {
  const data = [
    {
      image: AfricaBlockChainImage,
      title: "Key Reasons Why Your Business Needs Mobile SEO Services",
      subtitle:
        "In this comprehensive guide, we delve into the key reasons why your business needs to prioritize Mobile SEO Services for sustainable growth.",
      tags: "SEO Services",
      duration: "5 min",
    },
    {
      image: AfroLifestyleImage,
      title: "Technical SEO Services: Optimize and Rank your Website",
      subtitle:
        "In this comprehensive guide, we'll delve into the world of Technical SEO.",
      tags: "AI",
      duration: "12 min",
    },
    {
      image: AfroLifestyleImage,
      title: "How to Use AI for to Create Content that Converts",
      subtitle:
        "This article delves into the realm of AI for content creations.",
      tags: "SEO Services",
      duration: "15 min",
    },
    {
      image: AfricaBlockChainImage,
      title:
        "The Growing Adoption of Integrated AI—Top Business Applications for 2024",
      subtitle:
        "Since over half of businesses are using AI, where does that put your company in the marketplace?",
      tags: "SEO Services",
      duration: "5 min",
    },
    {
      image: AfricaBlockChainImage,
      title: "Technical SEO Services: Optimize and Rank your Website",
      subtitle:
        "In this comprehensive guide, we'll delve into the world of Technical SEO.",
      tags: "SEO Services",
      duration: "2 min",
    },
    {
      image: AfroLifestyleImage,
      title: "How to Use AI for to Create Content that Converts",
      subtitle:
        "This article delves into the realm of AI for content creations.",
      tags: "SEO Services",
      duration: "6 min",
    },
    {
      image: AfroLifestyleImage,
      title:
        "The Growing Adoption of Integrated AI—Top Business Applications for 2024",
      subtitle:
        "Since over half of businesses are using AI, where does that put your company in the marketplace?",
      tags: "SEO Services",
      duration: "4 min",
    },
    {
      image: AfricaBlockChainImage,
      title: "AfricaBlockChain",
      subtitle: "Featured - Blockchain, Website",
      tags: "SEO Services",
      duration: "7 min",
    },
  ];

  return (
    <div className="flex justify-center mt-[5vw] mb-[5vw]">
      <div className="w-full">
        {/* First Main Heading Div */}
        <div className="flex justify-center w-full px-[10%] max-sm:px-0">
          <div className="w-full">
            <div className="relative mb-[7vw] flex">
              <div
                style={{ backgroundImage: `url(${BlogPageLaptop})` }}
                className="w-[40vw] min-h-[40vw] bg-cover bg-[center] relative"
              ></div>
              {/* <div className="absolute top-20 left-80 w-[44vw] h-[28vw] bg-[#2B00AC]"> */}
              {/* content box */}
                  <div className="absolute top-1/2 left-[35%] transform -translate-y-1/2 bg-[#2B00AC] text-white p-4 w-[50vw] max-sm:relative max-sm:w-full max-sm:top-auto max-sm:left-auto max-sm:translate-y-0">
                <div className="flex items-center mb-[1vw]">
                  <button
                    className="border-white text-white border-[0.2vw] rounded-full px-[1vw] py-[0.2vw] text-[clamp(12px,14px,16px)] bg-transparent cursor-pointer hover:text-[#2B00AC] hover:bg-white transition duration-300"
                    disabled
                  >
                    SEO SERVICES
                  </button>
                  <p className="text-[clamp(10px,12px,14px)] text-white ml-[1vw]">
                    5 MIN Read
                  </p>
                </div>

                <div className=" text-left text-white">
                  <div className="flex">
                    <h1 className="text-[3.5vw]/[4.2vw] font-bold">
                      Key Reasons Why Your Business Needs Mobile SEO Services
                    </h1>
                  </div>
                  <div className="flex justify-between mt-[3vw]">
                    <p className="text-[clamp(12px,14px,16px)] mt-[-1vw]">
                      In this comprehensive guide, we delve into the key reasons
                      why your business needs to prioritize Mobile SEO Services
                      for sustainable growth.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Second Div */}
        <div className="h-[28vw]  max-sm:h-auto bg-[#2B00AC] p-[2vw] mt-[5vw] mb-[2vw]">
          <div className="flex justify-center mb-[3vw]">
            <h1 className="text-[3.5vw]/[4.2vw] font-bold text-white">
              LATEST ARTICLE
            </h1>
          </div>
          <div className="flex justify-around">
            <div className="flex text-left text-white max-sm:flex-col">
              <div className="p-5">
                <div className="mb-[2vw]">
                  <p className="text-[1.4vw] font-bold max-sm:text-[clamp(16px,16px,18px)]">
                    Technical SEO Services: Optimize and Rank your Website
                  </p>
                  <p className="text-[1.1vw] max-sm:text-[clamp(14px,12px,16px)]">
                    In this comprehensive guide, we'll delve into the world of
                    Technical SEO.
                  </p>
                </div>
                <button
                  className="border-white text-white max-sm:text-[clamp(12px,10px,14px)] border-[0.2vw] rounded-full px-[1vw] py-[0.2vw] text-[1vw] bg-transparent cursor-pointer hover:text-white hover:bg-[#D26B2F] transition duration-300"
                  disabled
                >
                  SEO SERVICES
                </button>
              </div>

              <div className="w-[0.2vw] bg-gray-300 h-[100%]" />

              <div className="p-5">
                <div className="mb-[2vw]">
                  <p className="text-[1.4vw] max-sm:text-[clamp(16px,14px,18px)] font-bold">
                    Technical SEO Services: Optimize and Rank your Website
                  </p>
                  <p className="text-[1.1vw] max-sm:text-[clamp(14px,12px,16px)]">
                    In this comprehensive guide, we'll delve into the world of
                    Technical SEO.
                  </p>
                </div>
                <button
                  className="border-white text-white max-sm:text-[clamp(12px,10px,14px)] border-[0.2vw] rounded-full px-[1vw] py-[0.2vw] text-[1vw] bg-transparent cursor-pointer hover:text-white hover:bg-[#D26B2F] transition duration-300"
                  disabled
                >
                  SEO SERVICES
                </button>
              </div>

              <div className="w-[0.2vw] bg-gray-300 h-[100%]" />

              <div className="p-5">
                <div className="mb-[2vw]">
                  <h1 className="text-[1.4vw] font-bold max-sm:text-[clamp(16px,14px,18px)]">
                    Technical SEO Services: Optimize and Rank your Website
                  </h1>
                  <p className="text-[1.1vw] max-sm:text-[clamp(14px,12px,16px)]">
                    In this comprehensive guide, we'll delve into the world of
                    Technical SEO.
                  </p>
                </div>
                <button
                  className="border-white max-sm:text-[clamp(12px,10px,14px)] text-white border-[0.2vw] rounded-full px-[1vw] py-[0.2vw] text-[1vw] bg-transparent cursor-pointer hover:text-white hover:bg-[#D26B2F] transition duration-300"
                  disabled
                >
                  SEO SERVICES
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Third Div */}
        <div className="flex justify-center">
          <div className="w-[80vw]">
            <div className="flex justify-between max-sm:flex-col max-sm:gap-3 text-left items-center pt-[2vw] mt-[5vw] mb-[2vw]">
              <div className=" w-[44vw] h-[28vw] max-sm:w-full max-sm:h-auto">
                <div className="m-[2vw]">
                  <div className="flex items-center">
                    <button
                      className="border-[#666666] text-[#666666] border-[0.2vw] rounded-full px-[1vw] py-[0.2vw] text-[1vw] max-sm:text-[clamp(12px,10px,14px)] bg-transparent cursor-pointer hover:text-white hover:bg-[#666666] transition duration-300"
                      disabled
                    >
                      SEO SERVICES
                    </button>
                    <p className="text-[1.1vw] max-sm:text-[clamp(12px,10px,14px)] ml-[1vw]">
                      5 MIN Read
                    </p>
                  </div>
                  <div className="text-left mt-[2vw]">
                    <div className="flex">
                      <h1 className="text-[2vw] font-bold max-sm:text-[clamp(16px,14px,18px)]">
                        Technical SEO Services: Optimize and Rank your Website
                      </h1>
                    </div>
                    <div className="flex justify-between mt-[3vw]">
                      <p className="text-[1.1vw] w-[80%] mt-[-1vw] max-sm:text-[clamp(14px,12px,16px)]">
                        In this comprehensive guide, we'll delve into the world
                        of Technical SEO.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[60vw] h-[30vw] max-sm:w-full bg-[center_right_-2vw]">
                <img
                  src={bloglist1}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="flex justify-between max-sm:flex-col-reverse max-sm:gap-3 text-left items-center pt-[2vw] mt-[5vw] mb-[2vw]">
              <div className="w-[60vw] h-[30vw] max-sm:w-full bg-[center_right_-2vw]">
                <img
                  src={bloglist2}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <div className=" w-[44vw] h-[28vw] max-sm:w-full max-sm:h-auto ml-[3vw]">
                <div className="m-[2vw]">
                  <div className="flex items-center">
                    <button
                      className="border-[#666666] text-[#666666] max-sm:text-[clamp(12px,10px,14px)] border-[0.2vw] rounded-full px-[1vw] py-[0.2vw] text-[1vw] bg-transparent cursor-pointer hover:text-white hover:bg-[#666666] transition duration-300"
                      disabled
                    >
                      AI
                    </button>
                    <p className="text-[1.1vw] ml-[1vw] max-sm:text-[clamp(12px,10px,14px)]">
                      5 MIN Read
                    </p>
                  </div>
                  <div className="text-left mt-[2vw]">
                    <div className="flex">
                      <h1 className="text-[2vw] font-bold max-sm:text-[clamp(16px,14px,18px)]">
                        How to Use AI for to Create Content that Converts
                      </h1>
                    </div>
                    <div className="flex justify-between mt-[3vw]">
                      <p className="text-[1.1vw] w-[80%] mt-[-1vw] max-sm:text-[clamp(14px,12px,16px)]">
                        This article delves into the realm of AI for content
                        creations.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-between max-sm:flex-col text-left items-center pt-[2vw] mt-[5vw] mb-[2vw]">
              <div className=" w-[44vw] h-[28vw] max-sm:w-full max-sm:h-auto">
                <div className="m-[2vw]">
                  <div className="flex items-center">
                    <button
                      className="border-[#666666] text-[#666666] max-sm:text-[clamp(12px,10px,14px)] border-[0.2vw] rounded-full px-[1vw] py-[0.2vw] text-[1vw] bg-transparent cursor-pointer hover:text-white hover:bg-[#666666] transition duration-300"
                      disabled
                    >
                      AI
                    </button>
                    <p className="text-[1.1vw] ml-[1vw] max-sm:text-[clamp(12px,10px,14px)]">
                      12 MIN Read
                    </p>
                  </div>
                  <div className="text-left mt-[2vw]">
                    <div className="flex">
                      <h1 className="text-[2vw] font-bold max-sm:text-[clamp(16px,14px,18px)]">
                        The Growing Adoption of Integrated AI—Top Business
                        Applications for 2024
                      </h1>
                    </div>
                    <div className="flex justify-between mt-[3vw]">
                      <p className="text-[1.1vw] w-[80%] mt-[-1vw] max-sm:text-[clamp(14px,12px,16px)]">
                        Since over half of businesses are using AI, where does
                        that put your company in the marketplace?
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[60vw] h-[30vw] max-sm:w-full bg-[center_right_-2vw]">
                <img
                  src={bloglist3}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        <Carousel cards={data} />

        {/* Last Div */}
        <CallToActionSection
          Content="We would love to hear more about your project"
          CallToAction="Let's Talk"
          Title="Work With Us"
        />
      </div>
    </div>
  );
}

export default Blog;
